import { render, staticRenderFns } from "./pageMenu.vue?vue&type=template&id=cdf2fe6e&scoped=true"
import script from "./pageMenu.vue?vue&type=script&lang=js"
export * from "./pageMenu.vue?vue&type=script&lang=js"
import style0 from "./pageMenu.vue?vue&type=style&index=0&id=cdf2fe6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf2fe6e",
  null
  
)

export default component.exports